import React, { useState } from "react";
import Table from "../../../../components/table";
import { TailSpin } from "react-loader-spinner";

import Icon from "../../../../assets/icons";
import { Modal } from "antd";
import RemovePrivilege from "./remove-privilege";

const RolePrivileges = ({ data, loading }: any) => {
  const [selectedUserId, setSelectedUserId] = useState<string | null>(null);
  const columns = [
    { header: "Name", accessor: "name" },
    { header: "Description", accessor: "description" },
    { header: "id", accessor: "updatedAt" },
  ];

  const handleUserClick = (_id: string) => {
    setSelectedUserId(_id);
  };

  const handleCloseModal = () => {
    setSelectedUserId(null);
  };

  return (
    <div className="rounded-md py-3 px-3 bg-white border border-[#fff] mt-10 w-[95%] pt-5 ">
      <div className="flex justify-between">
        <p className="text-[18px] font-semibold">Privileges for this role</p>
      </div>

      { loading?  (
        <div className="opacity-80 mt-10 font-bold w-[4%] mx-auto">
          <TailSpin color="skyblue" />
        </div>
      ) :  data?.length > 0 ? (
        <Table
          columns={columns}
          data={data}
          selectedUserId={null}
          onUserClick={handleUserClick}
        />
      ) : (<div className=" mt-10 text-center"> <p>No Privileges Assigned To This Role</p></div>) }
      { selectedUserId ? (
        <RemovePrivilege
          visible={!!selectedUserId}
          handleClose={handleCloseModal}
          id={selectedUserId}
        />
      ) : (
        <Modal
          visible={!!selectedUserId}
          onCancel={handleCloseModal}
          width={500}
          closable={false}
          footer={null}
        >
          <button onClick={handleCloseModal} className="flex ml-auto">
            <Icon name="cancelIcon" />
          </button>
          <h1 className="text-[#FF2D55] font-semibold text-[24px] text-center py-5">
            You do not have permission to delete this mediator
          </h1>
        </Modal>
      )}
    </div>
  );
};

export default RolePrivileges;
